<template>
  <div class="mt-5 mb-3">
    <template v-if="cardType === 'flower'">
      <CRow alignHorizontal="center">
        <div class="containerIconAudio">
          <font-awesome-icon
            class="IconAudio icon-audio-md"
            icon="volume-up"
            @click="playSound(soundObject)"
          ></font-awesome-icon>
        </div>
      </CRow>
      <CRow>
        <div class="pinyin-text">
          {{ cardContent.title[3].value }}
        </div>
      </CRow>
      <CRow style="display: flex; justify-content: center">
        <h1 class="vocab-text">{{ cardContent.title[2].value }}</h1>
      </CRow>
      
    </template>
    <template v-else>
      <CRow alignHorizontal="center">
        <div class="containerIconAudio">
          <font-awesome-icon
            class="IconAudio icon-audio-md"
            icon="volume-up"
            @click="playSound(soundObject)"
          ></font-awesome-icon>
        </div>
      </CRow>
      <CRow>
        <div class="pinyin-text">{{ cardContent.content.item[3].data }}</div>
      </CRow>
      <CRow style="display: flex; justify-content: center">
        <h1 class="vocab-text">{{ cardContent.content.item[2].data }}</h1>
      </CRow>
    </template>
  </div>
</template>

<script>
export default {
  components: {},
  name: "VocabAudio",
  props: {
    cardContent: Object,
    cardType: String,
    soundObject: HTMLAudioElement,
  },
  data() {
    return {
      baseUrl: process.env.VUE_APP_URL_SOUND,
      soundPath: "",
    };
  },

  computed: {},

  watch: {
    cardContent: function (val) {
    },
    soundObject: function(val){
    }
  },

  mounted() {},

  created() {},

  beforeDestroy() {
  },
  methods: {
    checkLangClass() {
      if (this.lang == "CN") {
        return "fontChinese";
      } else if (this.lang == "PIN IN") {
        return "fontPinin";
      } else {
        return "";
      }
    },
    playSound(audio) {
      if (audio) {
        audio.play();
      } else if (audio === "stop") {
        audio.pause();
        audio.currentTime = 0;
      }
    },
  },
};
</script>

<style scoped>
.icon-audio-md {
  font-size: 25px !important;
}
.containerIconAudio {
  /* display: flex;
  justify-content: center; */
  width: 40px;
  height: 40px;
  /* position: relative; */
  z-index: 10;
  /* left: 20px;
  top: 5px; */
}
.pinyin-text {
  font-family: "Bider";
  display: flex;
  text-align: center;
  font-size: 35px;
  color: #2c8dfb;
}
h1 {
  font-family: "KaiTi";
}
</style>
